import { Box, IconButton, Link } from "@mui/material";
import Iconify from "../../minimals/components/iconify";

export default function DownloadFileButton({ fileId }: { fileId: number }) {
  const momentumUrl = import.meta.env.VITE_MOMENTUM_URL;
  return (
    <Box>
      <Link href={`${momentumUrl}opendoc/download?id=${fileId}`} underline="none">
        <IconButton>
          <Iconify icon="eva:download-fill" />
        </IconButton>
      </Link>
    </Box>
  );
}
